
import { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import Loading from '../../Loading';
import { get_user } from '../../../api/api';
import { getRoles } from './../../../api/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const UserEdit = () => {

     const params = useParams()
     const navigate = useNavigate()

     const [user, setUser] = useState([])
     const [loading, setLoading] = useState(false)
     const [role, setRole] = useState([])
     const [bottonLoading, setBottonLoading] = useState(false)
     const [notFound, setNotFound] = useState(false)

     useEffect(() => {
          const roles = async () => {
               const res = await axios.get(getRoles)
               setRole(res.data)
          }
          roles()

          const getUserData = async () => {
               try {
                    setLoading(true)
                    const res = await axios.get(get_user(params.userId))
                    setUser(res.data)
               } catch (err) {
                    setNotFound(true)
               } finally {
                    setLoading(false)
               }
          }
          getUserData()

     }, [])



     const handleForm = async (e) => {
          e.preventDefault()
          setBottonLoading(true)

          let data = {
               firstName: e.target.firstName.value,
               lastName: e.target.lastName.value,
               mediaName: e.target.mediaName.value,
               userName: e.target.userName.value,
               email: e.target.email.value,
               shebaNumber: e.target.shebaNumber.value,
               subDomain: e.target.subDomain.value,
               gender: e.target.gender.value,
               roleId: e.target.roleId.value,
               lockoutEnabled: e.target.lockoutEnabled.value === 'true' ? true : false
          }

          try {
               await axios.put(get_user(params.userId), data)
               toast.success('کاربر با موفقیت ویرایش شد!')
               // navigate('/users/management')
          } finally {
               setBottonLoading(false)
          }


     }



     return (<>

          <div className='row' style={{ margin: '0' }}>
               <div className='col-12 searchTypeRow'>
                    <div className='topnav'>
                         <NavLink to={`/users/${params.userId}`}>ویرایش کاربر</NavLink>
                         <NavLink to={`/users/${params.userId}/traffic`}>مدیریت ترافیک</NavLink>
                    </div>
               </div>
          </div>



          {notFound
               ?
               (<p style={{ textAlign: 'center', marginTop: '100px' }}><button onClick={() => navigate(-1)}>بازگشت</button></p>)
               :
               (
                    loading ? <Loading /> : (
                         <>

                              <div className="contentHolder">
                                   <div className="row">
                                        <div className="col-12">
                                             <div className="box_radios padding">
                                                  <form onSubmit={handleForm}>
                                                       <p><input type="text" name='firstName' placeholder='نام' defaultValue={user.firstName} /></p>
                                                       <p><input type="text" name='lastName' placeholder='نام خانوادگی' defaultValue={user.lastName} /></p>
                                                       <p><input type="text" name='mediaName' placeholder='نام رسانه' defaultValue={user.mediaName} /></p>
                                                       <p><input type="text" name='email' placeholder='ایمیل' defaultValue={user.email} /></p>
                                                       <p><input type="text" name='userName' placeholder='تلفن همراه' defaultValue={user.userName} required /></p>

                                                       <p><input type="text" name='shebaNumber' placeholder='شماره شبا' defaultValue={user.shebaNumber} /></p>


                                                       {user.subDomain && user.subDomain !== '' ? (
                                                            <p><input className='readOnly' type="text" name='subDomain' placeholder='لینک اختصاصی' defaultValue={user.subDomain} readOnly /></p>
                                                       ) :
                                                            (<p><input type="text" name='subDomain' placeholder='لینک اختصاصی' defaultValue={user.subDomain} /></p>)
                                                       }

                                                       <p><label style={{ fontSize: '14px' }}>جنسیت : {' '}
                                                            <select name="gender" id="gender" defaultValue={user.gender}>
                                                                 <option value="1">مرد</option>
                                                                 <option value="0">زن</option>
                                                            </select>
                                                       </label></p>

                                                       <p><label style={{ fontSize: '14px' }}>نقش : {' '}
                                                            <select name="roleId" id="roleId" defaultValue={user.role?.id} >

                                                                 {role && role.map(i => (
                                                                      <option key={i.id} value={i.id}>{i.name}</option>
                                                                 ))}

                                                            </select>
                                                       </label></p>

                                                       <p><label style={{ fontSize: '14px' }}>وضعیت کاربر : {' '}
                                                            <select name="lockoutEnabled" id="lockoutEnabled" defaultValue={user.lockoutEnabled}>
                                                                 <option value={false}>فعال</option>
                                                                 <option value={true}>غیرفعال</option>
                                                            </select>
                                                       </label></p>

                                                       <p>{bottonLoading ? (<button type='button' className='disabled'>لطفا صبر کنید...</button>) : (<button type='submit'>ذخیره تغییرات</button>)}
                                                            <button className='goback' type='button' onClick={() => navigate('/users/management')}>بازگشت</button>
                                                       </p>
                                                  </form>
                                             </div>
                                        </div>
                                   </div>
                              </div>

                         </>
                    )
               )}
     </>)
}
export default UserEdit